import React from "react";
import { Row, Col } from "react-flexbox-grid";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import "./catalogo.css";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";

class ArticuloItem extends React.Component {
  constructor(props) {
    super(props);

    this.props.getImgArticulo(this.props.itemArticulo.idArticulo);
  }

  handleOnClickEliminarArticulo = () => {
    this.setState({
      modalConfirmarEliminacion: true,
    });
  };

  render() {
    return this.props.isGenerico ? (
      <div className="itemArticuloContainer">
        <div className="cardImgContainer">
          {this.props.imagenesArticulos !== undefined &&
          this.props.imagenesArticulos.imagenes[0] !== undefined &&
          this.props.imagenesArticulos.imagenes[0].imagen !== null ? (
            <div className="imageArticuloGenerico">
              <img
                alt=""
                src={`data:image/ief;base64,${this.props.imagenesArticulos.imagenes[0].imagen}`}
              />
            </div>
          ) : (
            <div className="imageDefault">
              <div>
                <img alt="Logo para producto sin foto" src={this.props.instalacion?.logoProducto} />
                <div style={{ color: "black" }}>Producto sin foto</div>
              </div>
            </div>
          )}
        </div>
        <div className="nombreArticulo">{this.props.itemArticulo.nombre}</div>
        <div className="rowButton row">
          <div className="btnsCantidad"></div>
          <div className="containerPrecios">
            <span
              className={`precioLista ${this.props.itemArticulo.precioPromocional ? "precioTachado" : ""}`}
            >
              ${this.props.itemArticulo.precioLista}
            </span>
            {this.props.itemArticulo.precioPromocional ? (
              <span className="precioClientazo">${this.props.itemArticulo.precioPromocional}</span>
            ) : (
              <span className="precioClientazo"></span>
            )}
          </div>
        </div>
        {/* BUTTON QUITAR */}

        {/* Botonera */}
        <div className="containerBtnsItemArticulo">
          <Row className="rowBtnsItemArticulo">
            {this.props.quitarProducto !== undefined && this.props.quitarProducto && (
              <Col
                xs
                className="btnDeshabilitar"
                onClick={(e) => {
                  this.props.handleOnClickEliminarArticulo(e, this.props.itemArticulo.idArticulo);
                }}
              >
                <Tooltip title="Quitar" placement="bottom">
                  <DeleteIcon className={`noDisponibleBtn`} />
                </Tooltip>
              </Col>
            )}
            {this.props.agregarProducto !== undefined && this.props.agregarProducto && (
              <Col
                xs
                className="btnDeshabilitar"
                onClick={(e) => {
                  this.props.handleOnClickAgregarArticulo(e, this.props.itemArticulo.idArticulo);
                }}
              >
                <Tooltip title="Agregar artículo al catálogo" placement="bottom">
                  <AddIcon className={`noDisponibleBtn`}></AddIcon>
                </Tooltip>
              </Col>
            )}
          </Row>
        </div>
      </div>
    ) : (
      <div
        className="itemArticuloTextilContainer"
        onClick={this.props.handleclick.bind(
          this,
          this.props.isGenerico,
          this.props.idSuperRubro,
          this.props.itemArticulo.idRubro,
          this.props.itemArticulo.idArticulo
        )}
      >
        {this.props.itemArticulo.listaImagenesArticulos !== undefined &&
        this.props.itemArticulo.listaImagenesArticulos.length > 0 &&
        this.props.itemArticulo.listaImagenesArticulos[0].imagen !== null ? (
          <img
            alt=""
            src={`data:image/ief;base64,${this.props.itemArticulo.listaImagenesArticulos[0].imagen}`}
            className="imagenArticulo"
          />
        ) : (
          <div>
            <CircularProgress />
            <div className="nombreItem">{this.props.itemArticulo.nombre}</div>
          </div>
        )}
      </div>
    );
  }
}

ArticuloItem.propTypes = {
  itemArticulo: PropTypes.object.isRequired,
  idCatalogo: PropTypes.object.isRequired,
  getImgArticulo: PropTypes.func.isRequired,
  instalacion: PropTypes.object,
};

ArticuloItem.defaultProps = {
  instalacion: { logoProducto: "" },
};

export default ArticuloItem;
